import { ReturnOnClickTypes } from '../types/misc/GenericTableTypes/ReturnOnClickTypes';
import { GenericRowActionConfiguration } from './GenericRowActionConfiguration';

/**
 * Represents the configuration for a generic action.
 * Extends the GenericRowActionConfiguration class.
 */
export class GenericActionConfiguration extends GenericRowActionConfiguration {
  /**
   * The type of return value on click events.
   * ('selection' | 'object')
   */
  returnType!: ReturnOnClickTypes;

  /**
   * An optional array of labels for the action.
   */
  label?: string[];

  /**
   * Constructs a new instance of GenericActionConfiguration.
   *
   * @param {Partial<GenericActionConfiguration>} [config] - An optional partial configuration object to initialize the instance.
   */
  constructor(config?: Partial<GenericActionConfiguration>) {
    super(config);
  }
}
